export default "__VITE_ASSET__DrOkX72J__"